import React from "react";
import { useTable } from "../../Components/useTable";

const FamilyRuleList = () => {
  const type = "Family Rule";
  const headCells = [
    { id: "level", numeric: false, label: "Level" },
    { id: "score", numeric: false, label: "Score" },
    { id: "frameForOwner", numeric: false, label: "Frame For Owner" },
    {
      id: "notificationAllBroad",
      numeric: false,
      label: "Notification All Broad",
    },
    { id: "familyTopScore", numeric: false, label: "Family Top Score" },
    { id: "entriesEffectSvg", numeric: false, label: "Entries Effect" },
    { id: "frameForTopScorers", numeric: false, label: "Top Score" },
    {
      id: "freeVoiceNoteForFamilyOwner",
      numeric: false,
      label: "Family Owner",
    },
    {
      id: "publicBulletMessageForFamilyOwner",
      numeric: false,
      label: "Public Family Owner",
    },
    {
      id: "bulletMessageForFamilyOwner",
      numeric: false,
      label: "Bullet Family Owner",
    },
    { id: "__v", numeric: false, label: "Version" },
    { id: "action", numeric: false, label: "Action" },
  ];

  const { tableUI } = useTable({
    headCells,
    type,
  });
  return (
    <div className="admin-body">
      <div className="table-area">{tableUI}</div>
    </div>
  );
};

export default FamilyRuleList;
